export default "<h3>COBOL Transformation Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"